import React from 'react';
import {
  Alert,
  Box,
  Button,
  Modal,
  Snackbar,
  Typography,
} from '@mui/material';
import colors from '../../../assets/theme/colors';
import ImportTimelineLoadingAnimation from './ImportTimelineLoadingAnimation';

const ImportReviewOverlays = ({
  showImportStartModal = false,
  onCloseImportStartModal,
  onLaunchImportPicker,
  importStartTitle = 'Add care source',
  importStartDescription = '',
  importStartHelper = '',
  importStartActionLabel = 'Choose upload',
  importLoading = false,
  importLoadingContent = {},
  importError = '',
  importStatus = '',
  onClearImportError,
  onClearImportStatus,
  isMobile = false,
}) => (
  <>
    <Modal
      open={showImportStartModal}
      onClose={onCloseImportStartModal}
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 420,
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 3,
          px: 3,
          py: 3,
          boxShadow: '0 24px 60px rgba(15, 23, 42, 0.14)',
          textAlign: 'left',
        }}
      >
        <Typography sx={{ fontSize: '1.15rem', fontWeight: 800, color: colors.landing.heroText, mb: 0.75 }}>
          {importStartTitle}
        </Typography>
        <Typography sx={{ fontSize: '0.92rem', lineHeight: 1.6, color: colors.landing.textMuted, mb: 2.5 }}>
          {importStartDescription}
        </Typography>
        <Typography sx={{ fontSize: '0.82rem', lineHeight: 1.5, color: colors.landing.textMuted, mb: 2.5 }}>
          {importStartHelper}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1.25, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
          <Button
            variant="text"
            onClick={onCloseImportStartModal}
            sx={{ px: 1.5 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onLaunchImportPicker}
            sx={{ px: 2.2 }}
          >
            {importStartActionLabel}
          </Button>
        </Box>
      </Box>
    </Modal>

    <Modal
      open={importLoading}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center", p: 2 }}
    >
      <Box
        sx={{
          bgcolor: "background.paper",
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 2.5,
          px: { xs: 2.5, sm: 3.25 },
          py: { xs: 2.5, sm: 3.25 },
          minWidth: { xs: 280, sm: 360 },
          maxWidth: 460,
          textAlign: "center",
          boxShadow: '0 20px 48px rgba(31, 58, 43, 0.12)',
        }}
      >
        <Box sx={{ mb: 2 }}>
          <ImportTimelineLoadingAnimation />
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.75, color: colors.landing.heroText }}>
          {importLoadingContent.title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.65 }}>
          {importLoadingContent.subtitle}
        </Typography>
      </Box>
    </Modal>

    <Snackbar
      open={Boolean(importError)}
      onClose={onClearImportError}
      anchorOrigin={isMobile ? { vertical: 'top', horizontal: 'center' } : { vertical: 'bottom', horizontal: 'center' }}
      sx={{ width: '100%' }}
    >
      <Alert
        onClose={onClearImportError}
        severity="error"
        variant="filled"
        sx={{
          width: { xs: 'calc(100vw - 24px)', sm: 'auto' },
          maxWidth: { xs: 'calc(100vw - 24px)', sm: 560 },
          alignItems: 'flex-start',
        }}
      >
        {importError}
      </Alert>
    </Snackbar>

    <Snackbar
      open={Boolean(importStatus) && !importError}
      autoHideDuration={5000}
      onClose={onClearImportStatus}
      anchorOrigin={isMobile ? { vertical: 'top', horizontal: 'center' } : { vertical: 'bottom', horizontal: 'center' }}
      sx={{ width: '100%' }}
    >
      <Alert
        onClose={onClearImportStatus}
        severity="info"
        variant="filled"
        sx={{
          width: { xs: 'calc(100vw - 24px)', sm: 'auto' },
          maxWidth: { xs: 'calc(100vw - 24px)', sm: 560 },
          alignItems: 'flex-start',
        }}
      >
        {importStatus}
      </Alert>
    </Snackbar>
  </>
);

export default ImportReviewOverlays;
